import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { UserService } from './user.service';

@Injectable()
export class NotAuth implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    let temp = this.userService.isAuthenticatedSubject;
    // console.log(temp.getValue());
    return !temp.getValue();

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/not-auth.service.ts